import { DateFormat, FormatDateChartLabelsProps } from "@ctypes";
import dayjs from "dayjs";

export const getDaysArray = (year = new Date().getFullYear(), month = 0) => {
  const date = new Date(year, month, 1);

  date.setMonth(date.getMonth() + 1);
  date.setDate(0);

  const daysInMonth = date.getDate();

  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
};

export const isMonthDisabled = (
  maxDate?: Date,
  minDate?: Date,
  selectedMonth?: number,
  selectedYear?: number,
) => {
  if (selectedYear != null && selectedMonth != null) {
    const selectedDate = new Date(selectedYear, selectedMonth);

    if (
      minDate &&
      dayjs(selectedDate).isBefore(dayjs(minDate)) &&
      minDate.getMonth() !== selectedMonth
    ) {
      return true;
    }

    if (dayjs(selectedDate).isAfter(maxDate)) {
      return true;
    }
  }
  return false;
};

export const isDayDisabled = (
  maxDate?: Date,
  minDate?: Date,
  selectedDay?: number,
  selectedMonth?: number,
  selectedYear?: number,
) => {
  if (selectedMonth != null && selectedYear != null && selectedDay != null) {
    const selectedDate = new Date(selectedYear, selectedMonth, selectedDay);

    if (minDate && dayjs(selectedDate).isBefore(dayjs(minDate))) {
      return true;
    }

    if (maxDate && dayjs(selectedDate).isAfter(maxDate)) {
      return true;
    }
  }
  return false;
};

export const formatChartDateLabels = ({ range, dates }: FormatDateChartLabelsProps) => {
  switch (range) {
    case "oneDay":
      return dates.map((d) => d.format(DateFormat.Time));
    case "oneWeek":
    case "oneMonth":
    case "sixMonth":
    case "oneYear":
      return dates.map((d) => d.format(DateFormat.ShortDate));
    case "fiveYear":
      return dates.map((d) => d.format(DateFormat.Year));
  }
};
